import { Controller } from "@hotwired/stimulus"

// Limits checkbox selection inside a model picker form to a max number
// (default 3). When the user reaches the cap, additional checkboxes are
// disabled until they uncheck one.
export default class extends Controller {
  static targets = ["checkbox", "counter"]
  static values = { max: { type: Number, default: 3 } }

  connect() {
    this.refresh()
  }

  enforceLimit() {
    this.refresh()
    this.element.requestSubmit()
  }

  refresh() {
    const checked = this.checkboxTargets.filter((cb) => cb.checked)
    const atCap = checked.length >= this.maxValue

    this.checkboxTargets.forEach((cb) => {
      cb.disabled = atCap && !cb.checked
    })

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${checked.length} of ${this.maxValue} selected`
    }
  }
}
